import { render, staticRenderFns } from "./wuhai_push.vue?vue&type=template&id=f56f9190&scoped=true&"
import script from "./wuhai_push.vue?vue&type=script&lang=js&"
export * from "./wuhai_push.vue?vue&type=script&lang=js&"
import style0 from "./wuhai_push.vue?vue&type=style&index=0&id=f56f9190&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f56f9190",
  null
  
)

export default component.exports